import { useEffect, useMemo, useState } from "react";
import ProductRow from "./Components/ProductRow";
import { whatsappLink } from "../../config/contact";
import { useCiT } from "../../common/ci/i18n";
import { slugify } from "../../utils/categoryPath";
import { TOP_CATEGORIES } from "../../config/topCategories";
import { Link, useLocation, useParams } from "react-router-dom";
import { Filters } from "./Components/Filters";
import Companies from "./Components/Companies";
import noProductFound from "../../assets/noProduct.png"
import { useSearchFiltersMutation } from "../../Redux/Api/ProductAPI";
import { CombinedState } from "../../types/api-types";
import Pagination from "./pagination";
import { MobileFilter } from "./Components/MobileFilter";
import { RingLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { addCompany, clearResults, resetPage, setCurrentPage, setSelectedCategories, } from "../../Redux/reducer/Filter";
import { Products } from "./Components/types";
import { DetailsBar } from "./Components/DetailsBar";
import RelatedSearch from "./Components/RelatedSearch";
import ErrorBoundary from "../../common/ErrorBoundaries";
import { chawlaispat } from "../../Redux/apiRoutes";
import usePageMeta from "../../common/hooks/usePageMeta";
import useJsonLd from "../../common/hooks/useJsonLd";
import { itemListSchema } from "../../common/seo/schema";
import { debounce } from "lodash";


interface ItemsProps {
  /** `/c/:slug` route se aata hai — URL params ki jagah seedha category */
  categoryId?: string;
  categoryName?: string;
  /** category ka intro (getCategories/publish se) — sirf /c/:slug par dikhta hai */
  categoryDescription?: string;
}

const Items = ({ categoryId, categoryName, categoryDescription }: ItemsProps) => {
  const location = useLocation();
  const params = useParams();
  const id = categoryId || params.id;
  const type = categoryId ? "category" : params.type;
  const t = useCiT();
  const dispatch = useDispatch();
  // const _id = id ? id : location?.state?.id

  let cat = type === "category" ? id : null
  let company = type === "company" ? id : null
  const catLabel = categoryName || (type === "category" ? decodeURIComponent(params.name || "") : "");
  const companyLabel = type === "company" ? decodeURIComponent(params.name || "") : "";
  // let company = location.state ? location?.state?.company : null;
  // const location = useLocation();
  // const dispatch = useDispatch();
  // let cat = location.state ? location?.state?.id : null;
  // let company = location.state ? location?.state?.company : null;
  const [sidebarCategory, setSidebarCategory] = useState<any>([]);
  const [sidebarCompany, setSidebarCompany] = useState<any>([]);
  const [searchFilters, { data: SearchProductsResponse, isLoading: isPriceLoading }] = useSearchFiltersMutation({},);
  const currentPage = useSelector((state: RootState) => state.selection.currentPage);
  const [isFetching, setIsFetching] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [combinedState, setCombinedState] = useState<CombinedState>({
    search: null,
    company: [],
    category: [],
    limit: 10,
    page: currentPage,
  });

  const [filters, setFilters] = useState<boolean>(false);
  const [smFilter, setSmFilter] = useState<any>();
  const [comFilter, setComFilter] = useState<any>();
  const [filterPosition, setFilterPosition] = useState(0);
  const [limit, setLimit] = useState<number>(6)

  const categoryBox = useSelector((state: RootState) => state.selection.selectedCategories);
  const companyBox = useSelector((state: RootState) => state.selection.selectedCompanies);
  const getMainSearch = useSelector((state: RootState) => state.selection.selectedSearch);

  useEffect(() => {
    if (location.pathname === '/items') {
      if (location.state?.fromSingleProduct) {
      } else {
        dispatch(resetPage());
      }
    }
  }, [location, dispatch]);


  const SmallFilter = (data: any) => {
    setSmFilter(data);
  };

  const SmallCompanyFilter = (data: any) => {
    setComFilter(data);
  };

  useEffect(() => {
    if (smFilter || comFilter) {
      setCombinedState((prevState) => ({
        ...prevState,
        search: null,
        category: smFilter || prevState.category,
        company: comFilter || prevState.company,
        page: 1,
      }));
      if (smFilter) setSidebarCategory(smFilter);
      if (comFilter) setSidebarCompany(comFilter)
    }
  }, [smFilter, comFilter]);



  // leading: true — pehli fetch turant jaati hai. Pehle har page load par 300 ms
  // khaali beetkar hi request nikalti thi, aur /c/:slug par wo 300 ms categories
  // ke RTT ke BAAD lagta tha. Filter badalne par trailing debounce waisa hi.
  // useMemo (useCallback nahi) taaki har render par naya debounce na bane, aur
  // unmount par cancel — warna listing chhodne ke baad bhi setIsFetching chalta tha.
  const fetchFilteredData = useMemo(
    () =>
      debounce(
        async (state) => {
          setIsFetching(true);
          try {
            // Category/company chuni ho (search nahi) to out-of-stock items customer ko nahi dikhne.
            const browsing =
              !state?.search &&
              ((state?.category?.length ?? 0) > 0 || (state?.company?.length ?? 0) > 0);
            await searchFilters({
              combinedState: browsing ? { ...state, inStockOnly: true } : state,
            });
          } catch (error) {
            console.error("Error fetching data:", error);
          } finally {
            setIsFetching(false);
          }
        },
        300,
        { leading: true, trailing: true }
      ),
    [searchFilters]
  );

  useEffect(() => () => fetchFilteredData.cancel(), [fetchFilteredData]);

  useEffect(() => {
    if (combinedState && Object.keys(combinedState).length > 0) {
      fetchFilteredData(combinedState);
    }
  }, [combinedState, fetchFilteredData]);


  useEffect(() => {
    setIsFetching(true);
    return () => {
      setIsFetching(false);
    };
  }, []);


  useEffect(() => {
    setCombinedState((prevState) => ({
      ...prevState,
      page: currentPage,
    }));
  }, [currentPage]);

  const onPageChange = (pageNumber: number) => {
    dispatch(setCurrentPage(pageNumber));
    setCombinedState((prevState) => ({
      ...prevState,
      page: pageNumber,
    }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const close = (data: any) => {
    setSidebarCategory([]);
    setSidebarCompany([]);
    setFilters(data);
  };

  const handleFilterButtonClick = () => {
    setFilters(!filters);
    if (!filters) {
      setFilterPosition(0);
    }
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth < 640);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const hasChanges = JSON.stringify(combinedState.category) !== JSON.stringify(categoryBox) ||
      JSON.stringify(combinedState.company) !== JSON.stringify(companyBox) || combinedState.search !== getMainSearch;

    if (hasChanges) {
      setCombinedState((prevState) => ({
        ...prevState,
        search: getMainSearch,
        category: categoryBox,
        company: companyBox,
        page: 1,
      }));
      setSidebarCategory(categoryBox);
    }
  }, [categoryBox, companyBox, getMainSearch]);

  useEffect(() => {
    if (cat) {
      dispatch(clearResults());
      dispatch(setSelectedCategories([cat]));
    }
  }, [cat, dispatch]);

  useEffect(() => {
    if (company) {
      dispatch(clearResults());
      dispatch(addCompany(company))
    }
  }, [company, dispatch]);

  const [hasResults, setHasResults] = useState<boolean>(false);

  useEffect(() => {
    if (SearchProductsResponse) {
      setHasResults(true);
    } else {
      setHasResults(false);
    }
  }, [SearchProductsResponse]);

  const total = useMemo(() => Math.ceil(SearchProductsResponse?.total / 10), [SearchProductsResponse?.total]);

  const title = catLabel
    ? `${catLabel} — Rate Today Rudrapur | Chawla Ispat`
    : companyLabel
    ? `${companyLabel} Products & Rate | Chawla Ispat`
    : "All Products — Steel, Cement, Pipe, Sheet | Chawla Ispat Rudrapur";
  const description = catLabel
    ? `${catLabel} ka aaj ka rate (GST sahit), brand aur size ke saath — Chawla Ispat, Rudrapur se seedha order.`
    : "Chawla Ispat Rudrapur — TMT bar, GC sheet, pipe, cement, hardware; rate GST sahit, quantity daal kar order.";
  // Sirf category listing ka canonical /c/<slug> par bhejo. Company listing ka
  // apna hi URL canonical rehna chahiye — sabko `${chawlaispat}/items` par
  // bhejne ka matlab hota har brand ka page index se bahar.
  const canonicalUrl =
    catLabel && slugify(catLabel) ? `${chawlaispat}/c/${slugify(catLabel)}` : undefined;
  // canonicalUrl pehle teesre argument me jaata tha — wo `baseUrl` hai, jisme se
  // hook sirf origin leta hai aur baaki path current pathname se banata hai.
  // Yaani legacy /items/<id>/category/<name> khud ko hi canonical batata tha,
  // /c/<slug> ko nahi. Ab wo asli canonical ki tarah jaata hai.
  // categoryName tabhi aata hai jab CategoryBySlug ne render kiya ho — wahan
  // meta wahi set karta hai, do component ek hi page par na likhein.
  usePageMeta(title, description, chawlaispat, {
    canonical: canonicalUrl,
    skip: !!categoryName,
  });

  const isLoadingState = isPriceLoading || isFetching
  // Category/company view me out-of-stock (status false) rows kabhi na dikhein —
  // backend inStockOnly se pehle hi hata deta hai, ye sirf safety net hai.
  const hideOutOfStock =
    !combinedState.search &&
    ((combinedState.category?.length ?? 0) > 0 || (combinedState.company?.length ?? 0) > 0);
  const products: Products[] = useMemo(
    () =>
      SearchProductsResponse?.products
        ? [...SearchProductsResponse.products]
            .filter((p: Products) => (hideOutOfStock ? !!p?.status : true))
            .sort(
              (a: Products, b: Products) => (b.status ? 1 : 0) - (a.status ? 1 : 0)
            )
        : [],
    [SearchProductsResponse, hideOutOfStock]
  );

  // ItemList schema schema.ts me likha pada tha par kahin mount nahi hota tha —
  // category page sirf BreadcrumbList bhej raha tha. Isse Google ko pata chalta
  // hai ki is page par kaunse product hain aur kis URL par.
  const itemListLd = useMemo(
    () =>
      catLabel && products.length
        ? itemListSchema(
            catLabel,
            products.slice(0, 20).map((pr) => ({
              name: String(pr.productName || ""),
              path: `/product/${pr.id}/${encodeURIComponent(pr.productName || "item")}`,
            }))
          )
        : null,
    [catLabel, products]
  );
  useJsonLd("itemlist", itemListLd);

  return (
    <div className="w-full bg-ci-bg">
      <DetailsBar total={SearchProductsResponse?.total} limit={limit} isLoading={isPriceLoading} hasResults={hasResults} onClick={handleFilterButtonClick} />
      {/* h1 category ke description par nirbhar nahi — pehle description na hone
          par page par ek bhi h1 nahi hota tha. */}
      {catLabel ? (
        <div className="mx-auto max-w-[1440px] px-3 pt-4 sm:px-5">
          <h1 className="text-[18px] font-bold sm:text-[20px]">{catLabel}</h1>
          {categoryDescription ? (
            <p className="mt-1 max-w-[860px] text-[14px] leading-relaxed text-ci-muted">
              {categoryDescription}
            </p>
          ) : null}
        </div>
      ) : null}
      {/* Related categories — sirf /c/:slug par; category pages aapas me jud jaate hain */}
      {catLabel ? (
        <div className="mx-auto max-w-[1440px] px-3 pt-3 sm:px-5">
          <span className="text-[13px] font-semibold text-ci-ink">{t("Related categories")}</span>
          <div className="mt-1.5 flex flex-wrap gap-2">
            {TOP_CATEGORIES.filter((c) => c.slug !== slugify(catLabel))
              .slice(0, 7)
              .map((c) => (
                <Link
                  key={c.slug}
                  to={`/c/${c.slug}`}
                  className="rounded-full border border-ci-line bg-white px-3 py-1.5 text-[13px] text-ci-ink hover:border-ci-navy"
                >
                  {c.label}
                </Link>
              ))}
          </div>
        </div>
      ) : null}
      <div className="mx-auto flex max-w-[1440px] gap-5 px-3 pb-8 pt-4 sm:px-5">
        {/* filters (desktop) */}
        <div className="sticky top-[150px] hidden w-[220px] shrink-0 flex-col gap-2.5 self-start sm:flex md:w-[260px]">
          <ErrorBoundary>
            <Filters />
          </ErrorBoundary>
          <Companies />
        </div>

        {/* mobile filters drawer */}
        <div
          id="mobile-filter"
          className={`fixed bottom-0 z-50 m-0 flex w-full flex-col justify-center gap-[0.6rem] overflow-y-auto border-t-[4px] bg-white p-0 shadow-inner transition-transform duration-300 ease-out sm:hidden ${filters ? "translate-y-0" : "invisible translate-y-full"}`}
          aria-hidden={!filters}
        >
          <MobileFilter
            smallFilter={SmallFilter}
            smallCompanyFilter={SmallCompanyFilter}
            close={close}
            sidebarCategory={sidebarCategory}
            sidebarCompany={sidebarCompany}
          />
        </div>

        {/* rows */}
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <div className="flex items-center justify-between text-[13px] text-ci-muted">
            <span className="flex items-center gap-2">
              <button type="button" onClick={handleFilterButtonClick} className="rounded-full border border-ci-line bg-white px-3 py-1.5 font-medium text-ci-ink sm:hidden">
                {t("Filters")}
              </button>
              {SearchProductsResponse?.total ? `${SearchProductsResponse.total} ${t("items")}` : ""}
            </span>
            <span className="hidden sm:inline">{t("Rates incl. GST · quantity daal kar seedha Add")}</span>
          </div>
          <div className="overflow-hidden rounded-lg border border-ci-line bg-white">
            <div className="hidden grid-cols-[minmax(0,1fr)_150px_170px_100px] gap-3 border-b border-ci-line px-4 py-2.5 text-[12px] uppercase tracking-wide text-ci-muted sm:grid">
              <span>{t("Item")}</span><span>{t("Rate / unit")}</span><span>{t("Quantity")}</span><span />
            </div>
            {isLoadingState ? (
              <div className="flex h-[40vh] items-center justify-center">
                <RingLoader color="#182A70" size={90} />
              </div>
            ) : products.length > 0 ? (
              products.map((product: Products) => <ProductRow key={product?.id} data={product} />)
            ) : (
              <div className="flex flex-col items-center gap-3 px-4 py-10 text-center">
                <img src={noProductFound} className="h-40 object-contain" alt="no products" />
                <span className="text-[14px] text-ci-muted">{t("Is naam/filter par kuch nahi mila — spelling badal kar ya category se dhoondhein.")}</span>
              </div>
            )}
          </div>
          <div className="rounded-lg border border-[#d5dde8] bg-[#eef2f7] px-4 py-3 text-[14px]">
            <b>{t("Bahut bada order?")}</b> {t("5 ton+ par WhatsApp par special rate —")}{" "}
            <a href={whatsappLink("Namaste, bulk order ka rate chahiye.")} target="_blank" rel="noreferrer" className="text-ci-orange2 underline">{t("quote maango")}</a>.
          </div>
          {getMainSearch ? <RelatedSearch search={getMainSearch} /> : null}
          {products.length > 0 ? (
            <div className="flex h-[72px] items-center justify-center">
              <Pagination total={total} current={currentPage} onPageChange={onPageChange} />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Items;
